import { StyledPortalFooterCard } from "./Footer.styles";

/**
 * PortalFooter
 *
 * Styled wrapper for portal footer content.
 *
 * Params
 * - children (React.ReactNode): The content to render inside the modal footer.
 * - ...rest (object): Additional props forwarded to the StyledModalFooterT1 component.
 *
 * Returns
 * - React.ReactElement: A StyledModalFooterT1 element wrapping the provided children.
 */
const PortalFooterCard = ({ children, ...rest }) => {
  return <StyledPortalFooterCard {...rest}>{children}</StyledPortalFooterCard>;
};

export { PortalFooterCard };
